import { createAction } from '@reduxjs/toolkit';
import { RoleLevelPermissionConstants } from '../permission.constants';

export const setRoleLevelPermissionsResponse = createAction<any>(RoleLevelPermissionConstants.PERMISSIONS_RESPONSE);

export const setCurrentPermissions = createAction<any>(RoleLevelPermissionConstants.ALL_PERMISSIONS);
export const setSystemLevelPermissions = createAction<any>(RoleLevelPermissionConstants.SYSTEM_LEVEL_PERMISSION);
